import SearchResultContent from './SearchResultsContent';

export default SearchResultContent;
